<template>
  <div :class="{'bill-controls-platform': true, 'h-100': hiddenTitle}" :style="hiddenTitle ? {overflow: 'hidden'} : {}">
    <a-row v-if="!hiddenTitle">
      <a-col :span="24">
        <div class="bill-kind-tabs-title d-flex align-items-center justify-content-between">
          <div>
            {{ listTitle }}
            <!-- <a-select v-if="isTop10" v-model="topLimit" @change="limitChange" style="width: 90px;">
              <a-select-option v-for="item in topOpts" :key="item.key" :value="item.key">{{ item.label }}</a-select-option>
            </a-select> -->
            <a-popover v-if="isTop10" v-model="visible" trigger="click" class="ml-1">
              <div slot="content">
                <a-select v-model="topLimit" @change="limitChange" style="width: 90px;">
                  <a-select-option v-for="item in topOpts" :key="item.key" :value="item.key">{{ item.label }}</a-select-option>
                </a-select>
              </div>
              {{topLimitText}}<a-icon class="ml-1" type="edit" />
            </a-popover>
          </div>
        </div>
        <div class="bill-kind-tabs-subtitle" v-if="subtitle">{{ subtitle }}</div>
      </a-col>
    </a-row>
    <a-row :gutter="24" :class="{'h-100': hiddenTitle}">
      <a-col :span="hiddenTitle ? 14 : 12" :class="{'h-100': hiddenTitle}">
        <scrollbar tag="ul" class="list-wrapper mt-2" :style="{height: hiddenTitle ? '100%' : '300px'}">
          <li :class="`list-item d-flex ${item.hidden ? 'opacity80' : ''}`" v-for="(item,index) in _dataList" :key="index">
            <div class="item-side">
              <div class="circle mr-2" :style="{'backgroundColor': item.hidden ? '#ccc' : item.color}" />
              <div class="name">{{ item[nameKey] }}</div>
            </div>
            <div class="item-side" style="flex-shrink:0">
              <div class="value"><span class="mr-1">{{ currencySign }}</span><list-body-cell-wrap copy :row="{value: valueShowType === 'resource_count' ? item[valueKey] : numerifyValue(item[valueKey]) }" field="value" :message="item[valueKey]" /> </div>
              <div class="percent ml-2" style="flex-shrink:0">{{ percent(item[valueKey]) }}</div>
            </div>
          </li>
          <a-alert v-if="_dataList.length === 0" :message="$t('bill.text_85')" banner />
        </scrollbar>
      </a-col>
      <a-col :span="hiddenTitle ? 10 : 12" :style="{height: hiddenTitle ? '100%' : '300px'}">
        <ring-base :seriesArr="ringDataList" :subtext="ringTotalMoney" :currencySign="currencySign" :colors="ringColors" :chartTitle="chartTitle || (valueShowType === 'resource_count' ? $t('bill.total') : '')" :valueShowType="valueShowType" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import * as R from 'ramda'
import RingBase from '@Bill/components/BillRing'
import { numerify } from '@/filters'
// import { chartColors } from '@/constants'
import setting from '@/config/setting'
import { currencyUnitMap } from '@/constants/currency'

const formatNumber = value => {
  if (!value || value === 'NaN' || isNaN(value) || R.isNil(value)) return 0
  return Number(value)
}

export default {
  name: 'PieList',
  components: {
    RingBase,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    nameKey: {
      type: String,
      default: 'item_name',
    },
    valueKey: {
      type: String,
      default: 'res_fee',
    },
    originNameKey: {
      type: String,
      default: 'origin_item_name',
    },
    listTitle: {
      type: String,
      required: true,
    },
    subtitle: String,
    currencySign: {
      type: String,
      default: currencyUnitMap.CNY.sign,
    },
    showZeroItem: {
      type: Boolean,
      default: false,
    },
    isTop10: Boolean,
    topLimit: Number,
    chartColors: Array,
    hiddenLegends: Array,
    hiddenTitle: {
      type: Boolean,
      default: false,
    },
    valueShowType: {
      type: String,
      default: 'resource_fee',
    },
    chartTitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      visible: false,
      topOpts: [
        { key: 10, label: 'TOP10' },
        { key: 20, label: 'TOP20' },
        { key: 30, label: 'TOP30' },
        { key: 0, label: this.$t('bill.text_259') },
      ],
    }
  },
  computed: {
    totalMoney () {
      const total = this.valueShowType === 'resource_count' ? this.dataList.reduce((a, b) => (+a) + (+b[this.valueKey]), 0) : numerify(this.dataList.reduce((a, b) => (+a) + (+b[this.valueKey]), 0), '0.00')
      return formatNumber(total)
    },
    _dataList () {
      const zero = ['0', '0.0', '0.00', '-0.00']
      return this.dataList
        .map((val, i) => {
          let value = 0
          if (val[this.valueKey]) value = this.valueShowType === 'resource_count' ? val[this.valueKey] : formatNumber(val[this.valueKey]).toFixed(2)
          let keyvalue = val[this.nameKey]
          if (keyvalue === 'OneCloud') {
            keyvalue = setting.brand[this.$store.getters.setting.language]
          }
          return { [this.nameKey]: keyvalue || val[this.nameKey], [this.valueKey]: value, hidden: this.hiddenLegends.includes(val[this.originNameKey]) || (this.hiddenLegends.includes('__others__') && i > 9) }
        })
        .filter(val => {
          return (val[this.valueKey] && !zero.includes(val[this.valueKey])) || this.showZeroItem
        })
        .sort((a, b) => {
          if (this.valueShowType === 'resource_count') {
            return b.count - a.count
          }
          return Number(b.res_fee) - Number(a.res_fee)
        })
        .map((val, i) => {
          return {
            ...val,
            color: this.chartColors[i] || this.chartColors[i % this.chartColors.length],
          }
        })
    },
    ringDataList () {
      return this._dataList.map((val, i) => {
        let color = this.chartColors[i] || this.chartColors[i % this.chartColors.length]
        if (val.hidden) {
          color = '#ccc'
        }
        return {
          ...val,
          color,
        }
      }).filter(item => { // 图中隐藏负数的费用
        return item[this.valueKey] && +(item[this.valueKey]) > 0
      })
    },
    ringColors () {
      return this.ringDataList.map(item => item.color)
    },
    ringTotalMoney () {
      const total = this.valueShowType === 'resource_count' ? this._dataList.reduce((a, b) => (+a) + (+(b.hidden ? 0 : b[this.valueKey])), 0) : numerify(this._dataList.reduce((a, b) => (+a) + (+(b.hidden ? 0 : b[this.valueKey])), 0), '0.00')
      return formatNumber(total)
    },
    topLimitText () {
      const target = this.topOpts.filter(item => item.key === this.topLimit)
      return target.length ? target[0]?.label : ''
    },
  },
  methods: {
    limitChange (val) {
      this.$emit('topLimitChange', val)
    },
    percent (num) {
      if (!this.totalMoney) return '0%'
      if (Number(num) === 0) return '0%'
      if (Number(num) < 0) return '-'
      const float = num / this.totalMoney
      if (float < 0.0001) {
        return '< 0.01%'
      }
      return `${numerify(float * 100, '0.00')}%`
    },
    numerifyValue (num) {
      return numerify(num, '0,0.00')
    },
    hide () {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
.bill-controls-platform {
  .list-wrapper {
    :global(.el-scrollbar__wrap) {
      overflow-x: hidden;
    }
    ::v-deep ul {
      list-style: none;
      padding-left: 0;
    }
    ::v-deep .is-horizontal {
      display: none;
    }
    ::v-deep .scrollbar-wrap {
      overflow-x: hidden;
    }
    .list-item {
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #dce0e6;
      font-size: 12px;
      justify-content: space-between;
      flex-wrap: nowrap;
      .item-side {
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
      .name {
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
      .value {
        color: #939eab;
        display: flex;
      }
      .percent {
        border: 1px solid #4da1ff;
        color: #4da1ff;
        height: 20px;
        line-height: 20px;
        margin-top: 10px;
        padding: 0 6px;
      }
      .circle {
        margin-top: 14px;
        height: 14px;
        width: 14px;
        border-radius: 50%;
        flex: 0 0 14px;
        // border: 1px solid #ccc;
      }
    }
    .opacity80 {
      opacity: 0.9;
      .name {
        color: #ccc;
      }
      .value {
        color: #ccc;
      }
      .percent {
        border: 1px solid #ccc;
        color: #ccc;
      }
    }
  }
}
</style>
